import { printAmount } from "common/src/helpers/functions";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import React from "react";

const DepositPredefined = ({ currencies, currency, setValue, skin }) => {
  let multiplier = 1;

  if (currency === "sek" || currency === "nok" || currency === "zar") {
    multiplier = 10;
  } else if (currency === "inr" || currency === "thb") {
    multiplier = 100;
  }

  return (
    <>
      <StyledButton
        fourth
        colfourth={skin === "rac" ? "col-sm-3" : "col-sm-3 float-left"}
        type="button"
        onClick={() => {
          setValue(30 * multiplier);
        }}
      >
        {printAmount(30 * multiplier * 100, currency, currencies, true)}
      </StyledButton>
      <StyledButton
        fourth
        colfourth={
          skin === "rac"
            ? "col-sm-3 col-sm-offset-1"
            : "col-sm-3 col-sm-offset-1 text-center"
        }
        type="button"
        onClick={() => {
          setValue(90 * multiplier);
        }}
      >
        {printAmount(90 * multiplier * 100, currency, currencies, true)}
      </StyledButton>
      <StyledButton
        fourth
        colfourth={
          skin === "rac"
            ? "col-sm-3 col-sm-offset-1"
            : "col-sm-3 col-sm-offset-1 float-right"
        }
        type="button"
        onClick={() => {
          setValue(150 * multiplier);
        }}
      >
        {printAmount(150 * multiplier * 100, currency, currencies, true)}
      </StyledButton>
    </>
  );
};

export default DepositPredefined;
